import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";

export default function ResetAuthorPassword() {
  const { token } = useParams(); // Extracts token from URL path (/resetpassword/:token)
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isValidToken, setIsValidToken] = useState(false);
  const [verifying, setVerifying] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // Validate token when user lands on page
  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setIsValidToken(false);
        setVerifying(false);
        return;
      }

      try {
        const response = await fetch(
          `https://panafricanbookexchange-wandererspath.com/api/auth/verify-reset-token/${token}`
        );
        
        const raw = await response.text();
        if (raw.startsWith("<!DOCTYPE") || raw.startsWith("<html")) {
          setIsValidToken(false);
          return;
        }

        const data = JSON.parse(raw);
        setIsValidToken(Boolean(data.valid));
      } catch (err) {
        console.error("Token verification error:", err);
        setIsValidToken(false);
      } finally {
        setVerifying(false);
      }
    };

    verifyToken();
  }, [token]);

  const handleReset = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!newPassword || !confirmPassword) {
      return alert("All fields are required");
    }

    if (newPassword !== confirmPassword) {
      return alert("Passwords do not match");
    }

    setLoading(true);

    try {
      const response = await fetch(
        "https://panafricanbookexchange-wandererspath.com/api/auth/reset-author-password",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, newPassword }),
        }
      );

      const raw = await response.text();
      let data;
      try {
        data = JSON.parse(raw);
      } catch (err) {
        setLoading(false);
        setErrorMsg("Server returned an invalid response. Please try again.");
        return;
      }

      setLoading(false);

      if (data.status === "ok") {
        alert("Password reset successful. Please login.");
        navigate("/admin");
      } else {
        setErrorMsg(data.error || data.message || "Password reset failed.");
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      setErrorMsg("Server error. Please try again.");
    }
  };

  if (verifying) {
    return (
      <div className="auth-inner text-center">
        <p>Verifying reset link integrity...</p>
      </div>
    );
  }

  if (!isValidToken) {
    return (
      <div className="auth-inner text-center">
        <h3>Link Expired or Invalid</h3>
        <p>This password reset token is invalid or has expired. Please request a new link.</p>
        <Link to="/forgot-password" className="btn btn-secondary mt-3">
          Request New Reset Link
        </Link>
      </div>
    );
  }

  return (
    <div className="auth-inner">
      <h3>Set New Password</h3>

      {errorMsg && <p className="text-danger mb-3">{errorMsg}</p>}

      <form onSubmit={handleReset}>
        <div className="form-group mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="New Password"
            value={newPassword}
            required
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>

        <div className="form-group mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="Confirm New Password"
            value={confirmPassword}
            required
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        <button type="submit" disabled={loading} className="btn btn-primary w-100">
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </div>
  );
}